export type KnowledgeCard = {
  id: string;
  title: string;
  url: string;
  thumbnail_url: string;
  sequence: number;
};

/**
 * GET /api/v1/knowledge-portal/
 */
export const GET_KNOWLEDGE_PORTAL_PATH = 'knowledge-portal';
export type GetKnowledgePortalRequestPathVariables = undefined;
export type GetKnowledgePortalRequestQueryParams = undefined;
export type GetKnowledgePortalSuccessDto = {
  count: number;
  next: string | null;
  previous: string | null;
  results: KnowledgeCard[];
};
export type GetKnowledgePortalErrorDto = Error;
